import { createContext, useContext } from "react";

type ContentFn = (sectionKey: string, fieldKey: string) => string;

const PageContentContext = createContext<ContentFn>(() => "");

export const PageContentProvider = PageContentContext.Provider;

export function useContent() {
  return useContext(PageContentContext);
}
